// Updated by Gauri on 18 Nov 2025 - Replaced CircularProgress with uiverse-loader for consistency
import 'app/views/common/Loader.css';

// Commented loader by Gauri on 18 Nov 2025
// import { CircularProgress, Box, styled } from "@mui/material";

// // STYLED COMPONENT
// const StyledLoading = styled("div")({
//   width: "100%",
//   height: "100%",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   "& img": {
//     width: "auto",
//     height: "25px"
//   },
//   "& .circleProgress": {
//     position: "absolute",
//     left: -7,
//     right: 0,
//     top: "calc(50% - 25px)"
//   }
// });

export default function Loading() {
  return (

    // Commented loader by Gauri on 18 Nov 2025
    // <StyledLoading>
    //   <Box position="relative">
    //     <img src="/assets/img/Insights_logo_original01.jpg" alt="" />
    //     <CircularProgress className="circleProgress" />
    //   </Box>
    // </StyledLoading>

    // Added by Gauri on 18 Nov 2025 - Added uiverse-loader
    <div className="loader-wrap">
      <div className="uiverse-loader small">
        <div className="ring"></div>
        <div className="ring"></div>
        <div className="ring"></div>
        <div className="ring"></div>
      </div>
    </div>
  );
}
